import { GroupSelect } from '~/pages/competition/groups/components/group-select';
import { RefereeRoleSelect } from '../roles/components/referee-duty-role';
import { schema, Schema } from './referee-duties-form.schema';
import { useCreateRefereeDutyMutation } from '../mutation';
import { zodResolver } from '@hookform/resolvers/zod';
import { Button } from '~/components/Button/Button';
import { Grid } from '~/components/Grid/Grid';
import { Input } from '~/components/Input';
import { Resolver, useForm } from 'react-hook-form';
import { toast } from 'react-toastify';

interface Props {
  refereeId: number;
  onFinish?: () => void;
}

export function RefereeDutiesForm({ refereeId, onFinish }: Props) {
  const mutationResult = useCreateRefereeDutyMutation();

  const { formState, register, handleSubmit } = useForm<Schema>({
    defaultValues: {},
    resolver: zodResolver(schema) as unknown as Resolver<Schema>,
  });

  async function onSubmit(data: Schema, id: number) {
    await toast.promise(mutationResult.mutateAsync({ payload: { ...data, judge: id } }), {
      success: 'Uppdraget har sparats',
      error: 'Något gick fel',
    });
    onFinish?.();
  }

  return (
    <form onSubmit={handleSubmit(data => onSubmit(data, refereeId))} autoComplete="off">
      <Grid>
        <Grid.Item cols={{ lg: 6, sm: 12 }}>
          <Input.Group formState={formState} htmlFor="group" label="Grupp">
            <GroupSelect {...register('group')} placeholder={'-'} formState={formState} />
          </Input.Group>
        </Grid.Item>
        <Grid.Item cols={{ lg: 6, sm: 12 }}>
          <Input.Group formState={formState} htmlFor="role" label="Roll">
            <RefereeRoleSelect {...register('role')} formState={formState} placeholder={'-'} />
          </Input.Group>
        </Grid.Item>
      </Grid>
      <Button.Group align="right">
        <Button type="submit">Spara</Button>
      </Button.Group>
    </form>
  );
}
